import React from "react";
import {
    BlockQuote,
    GoToAction,
    Cite,
    Deck,
    Heading,
    ListItem,
    List,
    Quote,
    Slide,
    Text
} from "spectacle";


const OurServices = () =>
    <div>
        <Heading size={4} textColor="tertiary" caps style={{paddingBottom: 30}}>
            What we do
        </Heading>
        <Heading size={6} textColor="secondary" caps>
            Boot camps
        </Heading>
        <Heading size={6} textColor="secondary" caps>
            Expert advisory
        </Heading>
        <Heading size={6} textColor="secondary" caps>
            Proof of concepts
        </Heading>
    </div>

export default OurServices;


// WEBPACK FOOTER //
// ./src/slides/OurServices.js